import { createFileRoute } from "@tanstack/react-router";
import { routeMeta } from "@/lib/route-meta";
import UserDashboard from "@/pages/UserDashboard";

export const Route = createFileRoute("/dashboard")({ head: () => routeMeta('My Property Dashboard | MNRE', 'View your MNRE property activity, saved searches and account details.', '/dashboard'), component: UserDashboard });
